import { render, staticRenderFns } from "./IzonayLogo.vue?vue&type=template&id=4c62a078&scoped=true&"
import script from "./IzonayLogo.vue?vue&type=script&lang=js&"
export * from "./IzonayLogo.vue?vue&type=script&lang=js&"
import style0 from "./IzonayLogo.vue?vue&type=style&index=0&id=4c62a078&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c62a078",
  null
  
)

export default component.exports